import {StyledTabItem, StyledTabWrapper} from '@/features/measures/components/filters/tab-filter/style.ts'
import {useTranslation} from 'react-i18next'
import {FC} from 'react'

export interface TabFilterProps {
    setActiveFiltersTab: (tab: 'all' | 'opinion' | 'judgment' | 'decree' | 'ordinance') => void
    activeFiltersTab: 'all' | 'opinion' | 'judgment' | 'decree' | 'ordinance'
    options: ('opinion' | 'judgment' | 'decree' | 'ordinance')[]
}

export const TabFilter: FC<TabFilterProps> = ({options, setActiveFiltersTab, activeFiltersTab}) => {
    const {t} = useTranslation()

    return (
        <StyledTabWrapper>
            <StyledTabItem $isActive={Boolean(activeFiltersTab === 'all')} onClick={() => setActiveFiltersTab('all')}>
                {t('measures:filters:all')}
            </StyledTabItem>
            {options?.map(option => (
                <StyledTabItem
                    key={option}
                    $isActive={Boolean(activeFiltersTab === option)}
                    onClick={() => setActiveFiltersTab(option)}
                >
                    {t(`measures:filters:${option}`)}
                </StyledTabItem>
            ))}
        </StyledTabWrapper>
    )
}
